import { render, staticRenderFns } from "./hcd-area-select.vue?vue&type=template&id=80ee142c&scoped=true"
import script from "./hcd-area-select.vue?vue&type=script&lang=js"
export * from "./hcd-area-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ee142c",
  null
  
)

export default component.exports